// state/userSignupReducer.ts

import { DocumentType } from '@/core/enums/document-type';
import { OtpChannel } from '@/core/enums/otp-channel.enum';

export interface UserSignupState {
  id?: string;
  sessionId?: string;
  // Request OTP
  documentType?: DocumentType;
  documentNo?: string;
  firstName?: string;

  // Verification Status
  isVerified: boolean;

  otpChannel?: OtpChannel;
  phoneNumber?: string;
  email?: string;

  // Verify OTP
  otpCode?: string;
  otpReference?: string;

  // Complete Signup

  surname?: string;
  otherNames?: string | null;
  password?: string;
  confirmPassword?: string;
}

export const initialUserSignupState: UserSignupState = {
  documentType: DocumentType.NationalId,
  otpChannel: OtpChannel.Sms,
  isVerified: false,
  documentNo:"",
  firstName:"",
  phoneNumber:"",
  email:'' 
};

export type UserSignupAction =
  | {
      type: 'UPDATE';
      payload: Partial<UserSignupState>;
    }
  | {
      type: 'RESET';
    };

export const userSignupReducer = (state: UserSignupState, action: UserSignupAction): UserSignupState => {
  switch (action.type) {
    case 'UPDATE':
      return {
        ...state,
        ...action.payload,
        
      };

    case 'RESET':
      return initialUserSignupState;

    default:
      return state;
  }
};
